export const fetchAllBlogPosts = async () => {
  try {
    const response = await fetch(`https://blog.ebmconsultores.com.mx/wp-json/wp/v2/posts?_embed&per_page=100&_=${Date.now()}`)
    if (!response.ok) throw new Error("Error al cargar los posts");
    const data = await response.json();

    return data.map((post) => {
      const titulo = post.title?.rendered || "Sin título";
      const enlace = post.link || `/blog/${post.slug || post.id}`;
      const fecha = post.date || "";
      const contenidoCompleto = post.content?.rendered || "";

      // 1. Intenta obtener la imagen destacada desde _embedded
      let imagenDestacada = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;

      // 2. Si no hay imagen destacada, busca la primera imagen dentro del contenido HTML
      if (!imagenDestacada) {
        const imgRegex = /<img[^>]+src=["']([^"']+)["']/i;
        const match = contenidoCompleto.match(imgRegex);
        if (match && match[1]) {
          imagenDestacada = match[1];
        }
      }

      // 3. Si aún no se encuentra imagen, usar imagen genérica
      if (!imagenDestacada) {
        imagenDestacada = "https://res.cloudinary.com/dhoyyqszi/image/upload/v1749420902/ebm/imagen-generica-blog_yqr0yz.png";
      }

      // Quitar etiquetas HTML del extracto
      const descripcion = post.excerpt?.rendered?.replace(/<[^>]+>/g, "").trim() || "Sin descripción";

      // Obtener nombres de categorías
      const categorias = post._embedded?.['wp:term']
        ?.flat()
        ?.filter(cat => cat?.taxonomy === 'category')
        ?.map(cat => cat.name)
        || ["Sin categoría"];

      return {
        titulo,
        enlace,
        imagen: imagenDestacada,
        descripcion,
        contenidoCompleto,
        categoria: categorias,
        fecha,
      };
    });
  } catch (error) {
    console.error("Error fetching blog posts:", error);
    return [];
  }
};
